import { renderPage } from "renderPage"
import { PageIndexPage } from "./Page"

renderPage({ component: PageIndexPage })
